<app-header class="fixed-header" [title]="LITERALS.USERS.TITTLE"></app-header>
<p-sidebar
  class="fixed-sidebar"
  styleClass="menu-filter"
  [modal]="false"
  [(visible)]="filterDisplay"
  (onShow)="onResize()"
  position="left"
>
  <app-user-filter
    (closeHimself)="filterDisplay = false"
    [table]="userTable"
    [today]="today"
    [isFiltered]="isFiltered"
    [filteredUsers]="filteredUsers"
    (filterStatusChange)="onFilterStatusChange($event)"
    (dateFilterApplied)="onDateFilterApplied()"
  ></app-user-filter>
</p-sidebar>

<div class="movanoMiddleBar fixed-middle-bar">
  <div class="movanoMiddleBar_First">
    <app-calendar
      #list_calendar
      [slctdDateOpt]="selectedDate"
      (initGetInfo)="emitGetInfo($event)"
      [timeZones]="timeZones"
      [ngStyle]="{ 'pointer-events': valueSearch ? 'none' : 'auto', opacity: valueSearch ? '0.5' : '1' }"
    ></app-calendar>
    <svg
      class="movanoHeader_Tittle_btn"
      style="margin-left: 20px"
      width="max(1.11vw, 16px)"
      height="max(1.11vw, 16px)"
      *ngIf="!searchDisplay"
      (click)="searchDisplay = true"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
        fill="var(--main-blue-dark)"
      />
    </svg>
    <div
      style="margin-right: 20px; margin-left: 20px"
      *ngIf="searchDisplay"
      class="movanoHeader_Tittle_Search scale-up-hor-left"
    >
      <svg
        (click)="search($event, 'user_id', userTable)"
        width="max(1.11vw, 16px)"
        height="max(1.11vw, 16px)"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
          fill="var(--main-blue-dark)"
        />
      </svg>
      <span class="p-input-icon-left">
        <input
          class="movanoInputSearch"
          type="text"
          placeholder="Search user"
          #searchInput
          pInputText
          (input)="search($event, 'user_id', userTable)"
        />
      </span>
      <svg
        width="max(0.833vw, 16px)"
        height="max(0.833vw, 16px)"
        (click)="clearSearch(searchInput, userTable); searchDisplay = false; this.isFiltered = false"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
          fill="#C4D9EE"
        />
      </svg>
    </div>
    <!-- <svg
      style="margin-left: 20px"
      (click)="filterDisplay = true"
      class="movanoHeader_Tittle_btn"
      width="max(0.9vw, 16px)"
      height="max(0.9vw, 16px)"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.364543 1.48084C0.443709 1.58375 4.90871 7.28375 4.90871 7.28375V12.0417C4.90871 12.4771 5.26496 12.8333 5.70829 12.8333H7.29954C7.73496 12.8333 8.09913 12.4771 8.09913 12.0417V7.27584C8.09913 7.27584 12.4454 1.71834 12.6512 1.465C12.857 1.21167 12.8333 0.958338 12.8333 0.958338C12.8333 0.522922 12.477 0.166672 12.0337 0.166672H0.966209C0.483293 0.166672 0.166626 0.546672 0.166626 0.958338C0.166626 1.11667 0.214126 1.30667 0.364543 1.48084Z"
        fill="var(--main-blue-dark)"
      />
    </svg> -->
  </div>

  <div class="movanoMiddleBar_Last">
    <span class="movanoMiddleBar_Last_Amount">{{ customersTotal }} users</span>

    <svg
      style="margin-right: 30px; cursor: pointer"
      (click)="exportCSV()"
      width="max(1.11vw, 17px)"
      height="max(1.11vw, 19px)"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.186 1.1897e-05H4.60464L3.00801 0L3 16C3 16 3.71406 16 4.59662 16H13.3953C14.2779 16 15 16 15 16V4.75109L10.186 1.1897e-05ZM13.3953 14.393H4.60464V1.53712H9.38372V5.55458H13.3953V14.393Z"
        fill="#054280"
      />
      <path d="M0 10H17V19H0V10Z" fill="#054280" />
      <path d="M12.8696 17L11.1546 12.1H12.1276L13.3316 15.775L14.5426 12.1H15.5156L13.7936 17H12.8696Z" fill="white" />
      <path
        d="M8.99207 17.105C8.57207 17.105 8.18474 17.014 7.83007 16.832C7.48007 16.6453 7.2024 16.3303 6.99707 15.887L7.76007 15.467C7.8954 15.7097 8.05874 15.8987 8.25007 16.034C8.4414 16.1693 8.7004 16.237 9.02707 16.237C9.34907 16.237 9.56374 16.1833 9.67107 16.076C9.7784 15.964 9.83207 15.817 9.83207 15.635C9.83207 15.5183 9.80407 15.418 9.74807 15.334C9.69674 15.25 9.58007 15.1707 9.39807 15.096C9.22074 15.0167 8.9454 14.9327 8.57207 14.844C8.1194 14.7367 7.78574 14.564 7.57107 14.326C7.3564 14.088 7.24907 13.7917 7.24907 13.437C7.24907 13.143 7.31907 12.8863 7.45907 12.667C7.59907 12.4477 7.79507 12.2773 8.04707 12.156C8.30374 12.03 8.60474 11.967 8.95007 11.967C9.2674 11.967 9.5474 12.016 9.79007 12.114C10.0327 12.212 10.2381 12.3403 10.4061 12.499C10.5787 12.6577 10.7141 12.8303 10.8121 13.017L10.0911 13.556C10.0211 13.444 9.93474 13.3343 9.83207 13.227C9.73407 13.115 9.61274 13.0217 9.46807 12.947C9.3234 12.8723 9.14607 12.835 8.93607 12.835C8.71674 12.835 8.53707 12.8817 8.39707 12.975C8.26174 13.0637 8.19407 13.2037 8.19407 13.395C8.19407 13.4697 8.21274 13.5467 8.25007 13.626C8.29207 13.7007 8.3854 13.7753 8.53007 13.85C8.6794 13.9247 8.91507 14.0017 9.23707 14.081C9.78307 14.2117 10.1774 14.4077 10.4201 14.669C10.6674 14.9257 10.7911 15.243 10.7911 15.621C10.7911 16.1017 10.6277 16.4703 10.3011 16.727C9.97907 16.979 9.54274 17.105 8.99207 17.105Z"
        fill="white"
      />
      <path
        d="M4.54096 17.119C4.09762 17.119 3.70096 17.014 3.35096 16.804C3.00096 16.594 2.72562 16.2977 2.52496 15.915C2.32896 15.5277 2.23096 15.0727 2.23096 14.55C2.23096 14.0227 2.32896 13.5677 2.52496 13.185C2.72562 12.7977 3.00096 12.499 3.35096 12.289C3.70096 12.0743 4.09762 11.967 4.54096 11.967C4.95629 11.967 5.32962 12.0603 5.66096 12.247C5.99696 12.4337 6.26529 12.695 6.46596 13.031L5.65396 13.5C5.53729 13.2947 5.38329 13.136 5.19196 13.024C5.00529 12.912 4.78829 12.856 4.54096 12.856C4.26562 12.856 4.02529 12.9283 3.81996 13.073C3.61929 13.213 3.46296 13.409 3.35096 13.661C3.23896 13.913 3.18296 14.2093 3.18296 14.55C3.18296 14.886 3.23896 15.18 3.35096 15.432C3.46296 15.684 3.61929 15.8823 3.81996 16.027C4.02529 16.167 4.26562 16.237 4.54096 16.237C4.78829 16.237 5.00529 16.181 5.19196 16.069C5.38329 15.9523 5.53729 15.7937 5.65396 15.593L6.46596 16.062C6.26529 16.3933 5.99696 16.6523 5.66096 16.839C5.32962 17.0257 4.95629 17.119 4.54096 17.119Z"
        fill="white"
      />
    </svg>

    <!-- <svg
      style="margin-right: 19px"
      width="max(1.11vw, 16px)"
      height="max(1.11vw, 16px)"
      viewBox="0 0 3 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <circle cx="1.5" cy="1.5" r="1.5" fill="#054280" />
        <circle cx="1.5" cy="7.5" r="1.5" fill="#054280" />
        <circle cx="1.5" cy="13.5" r="1.5" fill="#054280" />
      </g>
    </svg> -->
  </div>
</div>

<div class="movanoUsers" [ngClass]="{ movanoDark: darkMode }">
  <div [ngStyle]="{ display: !loadingUserList ? 'block' : 'none' }" class="movanoTableBox">
    <p-table
      id="userTable"
      #userTable
      class="movano-Table"
      [globalFilterFields]="[
        'user_id',
        'gender',
        'age',
        'register_date',
        'country',
        'state',
        'last_sync',
        'devices',
        'bugs',
        'tickets'
      ]"
      [value]="users"
      [paginator]="true"
      [rows]="rows"
      [first]="pageSelected"
      (onFilter)="onFilter($event)"
      [scrollable]="true"
      scrollHeight="75vh"
    >
      <ng-template pTemplate="header">
        <tr [ngClass]="'movanoTable_Header'">
          <th (click)="sort('customerUuid')">
            {{ LITERALS.USERS.TABLE_USER_ID }}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="customerUuid-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('gender')">
            {{ LITERALS.USERS.TABLE_GENDER }}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="gender-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('age')">
            {{ LITERALS.USERS.TABLE_AGE }}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="age-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('dateCreatedUtc')">
            {{ LITERALS.USERS.TABLE_REGISTER_DATE
            }}<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="dateCreatedUtc-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('country')">
            {{ LITERALS.USERS.TABLE_COUNTRY
            }}<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="country-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('state')">
            {{ LITERALS.USERS.TABLE_STATE
            }}<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="state-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('lastSync')">
            {{ LITERALS.USERS.TABLE_LAST_SYNC
            }}<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="lastSync-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('devices')">
            {{ LITERALS.USERS.TABLE_DEVICES
            }}<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                id="devices-icon"
                d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                fill="#C4D9EE"
              />
            </svg>
          </th>
          <th (click)="sort('bugs')">
            {{ LITERALS.USERS.TABLE_BUGS
            }}
          </th>
          <th (click)="sort('tickets')">
            {{ LITERALS.USERS.TABLE_TICKETS
            }}
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-i="rowIndex">
        <tr
          [ngStyle]="{
            background: darkMode ? (i % 2 == 0 ? '#05294d' : '#05305B') : i % 2 == 0 ? '#f3f6f9' : 'white'
          }"
          [ngClass]="'movanoTable_Obj'"
        >
          <td>{{ product.customerUuid }}</td>
          <td>
            <div
              *ngIf="product.gender === 'F' || product.gender === 'W'"
              class="movanoTable_Obj_Badge movanoTable_Obj_Badge_Female"
            >
              {{ LITERALS.MOVANO.FEMININE }}
            </div>
            <div *ngIf="product.gender === 'M'" class="movanoTable_Obj_Badge">{{ LITERALS.MOVANO.MASCULINE }}</div>
            <div *ngIf="product.gender === 'O'" class="movanoTable_Obj_Badge movanoTable_Obj_Badge_NoBinary">
              {{ LITERALS.MOVANO.NON_BINARY }}
            </div>
          </td>
          <td>{{ product.age }}</td>
          <td>{{ product.dateCreatedUtc | date : "MM/dd/yy" }}</td>
          <td>{{ product.country }}</td>
          <td>{{ product.state }}</td>
          <td>{{ product.lastSync | date : "MM/dd/yy" }}</td>
          <td class="movanoTable_click" (click)="openUserDevicesPanel(product.customerUuid)">
            <div style="display: flex">
              <span>{{ product.devices }}</span>
              <svg
                style="margin-left: 10px; margin-top: 4px"
                width="max(1vw,14px)"
                height="max(1vw,14px)"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="remove_red_eye" clip-path="url(#clip0_1510_2444)">
                  <path
                    id="Vector"
                    d="M7.00004 3.79167C9.21087 3.79167 11.1825 5.03417 12.145 7C11.1825 8.96583 9.21671 10.2083 7.00004 10.2083C4.78337 10.2083 2.81754 8.96583 1.85504 7C2.81754 5.03417 4.78921 3.79167 7.00004 3.79167ZM7.00004 2.625C4.08337 2.625 1.59254 4.43917 0.583374 7C1.59254 9.56083 4.08337 11.375 7.00004 11.375C9.91671 11.375 12.4075 9.56083 13.4167 7C12.4075 4.43917 9.91671 2.625 7.00004 2.625ZM7.00004 5.54167C7.80504 5.54167 8.45837 6.195 8.45837 7C8.45837 7.805 7.80504 8.45833 7.00004 8.45833C6.19504 8.45833 5.54171 7.805 5.54171 7C5.54171 6.195 6.19504 5.54167 7.00004 5.54167ZM7.00004 4.375C5.55337 4.375 4.37504 5.55333 4.37504 7C4.37504 8.44667 5.55337 9.625 7.00004 9.625C8.44671 9.625 9.62504 8.44667 9.62504 7C9.62504 5.55333 8.44671 4.375 7.00004 4.375Z"
                    [ngStyle]="{ fill: darkMode ? 'white' : '#054280' }"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1510_2444">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </td>
          <td class="movanoTable_click" (click)="openBugsPanel(product.customerUuid)">
            <svg viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.25 6.00004H12.8925C12.555 5.41504 12.09 4.91254 11.5275 4.53004L12.225 3.83254C12.5175 3.54004 12.5175 3.06754 12.225 2.77504C11.9325 2.48254 11.46 2.48254 11.1675 2.77504L10.065 3.87754C9.72 3.79504 9.3675 3.75004 9 3.75004C8.6325 3.75004 8.28 3.79504 7.9425 3.87754L6.8325 2.77504C6.54 2.48254 6.0675 2.48254 5.775 2.77504C5.4825 3.06754 5.4825 3.54004 5.775 3.83254L6.465 4.53004C5.91 4.91254 5.445 5.41504 5.1075 6.00004H3.75C3.3375 6.00004 3 6.33754 3 6.75004C3 7.16254 3.3375 7.50004 3.75 7.50004H4.5675C4.53 7.74754 4.5 7.99504 4.5 8.25004V9.00004H3.75C3.3375 9.00004 3 9.33754 3 9.75004C3 10.1625 3.3375 10.5 3.75 10.5H4.5V11.25C4.5 11.505 4.53 11.7525 4.5675 12H3.75C3.3375 12 3 12.3375 3 12.75C3 13.1625 3.3375 13.5 3.75 13.5H5.1075C5.8875 14.8425 7.335 15.75 9 15.75C10.665 15.75 12.1125 14.8425 12.8925 13.5H14.25C14.6625 13.5 15 13.1625 15 12.75C15 12.3375 14.6625 12 14.25 12H13.4325C13.47 11.7525 13.5 11.505 13.5 11.25V10.5H14.25C14.6625 10.5 15 10.1625 15 9.75004C15 9.33754 14.6625 9.00004 14.25 9.00004H13.5V8.25004C13.5 7.99504 13.47 7.74754 13.4325 7.50004H14.25C14.6625 7.50004 15 7.16254 15 6.75004C15 6.33754 14.6625 6.00004 14.25 6.00004ZM9.75 12H8.25C7.8375 12 7.5 11.6625 7.5 11.25C7.5 10.8375 7.8375 10.5 8.25 10.5H9.75C10.1625 10.5 10.5 10.8375 10.5 11.25C10.5 11.6625 10.1625 12 9.75 12ZM9.75 9.00004H8.25C7.8375 9.00004 7.5 8.66254 7.5 8.25004C7.5 7.83754 7.8375 7.50004 8.25 7.50004H9.75C10.1625 7.50004 10.5 7.83754 10.5 8.25004C10.5 8.66254 10.1625 9.00004 9.75 9.00004Z"
                fill="#E31482"
              />
            </svg>
          </td>
          <td class="movanoTable_click" (click)="openTicketsPanel(product.customerUuid)">
            <svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.75 8H1.41667C0.6375 8 0.00708333 8.6375 0.00708333 9.41667L0 22.1667L2.83333 19.3333H12.75C13.5292 19.3333 14.1667 18.6958 14.1667 17.9167V9.41667C14.1667 8.6375 13.5292 8 12.75 8Z"
                fill="#E22B2B"
              />
              <path
                d="M6.909 15.146L6.72 10.7H7.953L7.764 15.146H6.909ZM7.332 17.135C7.128 17.135 6.954 17.066 6.81 16.928C6.672 16.784 6.603 16.61 6.603 16.406C6.603 16.202 6.672 16.031 6.81 15.893C6.954 15.749 7.128 15.677 7.332 15.677C7.536 15.677 7.71 15.749 7.854 15.893C7.998 16.031 8.07 16.202 8.07 16.406C8.07 16.61 7.998 16.784 7.854 16.928C7.71 17.066 7.536 17.135 7.332 17.135Z"
                fill="white"
              />
            </svg>
          </td>
          <td class="movanoTable_click" (click)="openUserPanel(product.customerUuid)">
            <svg viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Group 721">
                <path id="Vector 23" d="M1 7V12" stroke="#0B84FF" stroke-width="2" stroke-linecap="round" />
                <path id="Vector 24" d="M6 4L6 12" stroke="#0B84FF" stroke-width="2" stroke-linecap="round" />
                <path id="Vector 25" d="M11 1L11 12" stroke="#0B84FF" stroke-width="2" stroke-linecap="round" />
              </g>
            </svg>
          </td>
          <td class="movanoTable_click" (click)="openNtfPanel(product.customerUuid, product.notifications)">
            <div *ngIf="product.notifications > 0" style="display: flex; gap: 10px">
              <span style="font-weight: 700">{{ product.notifications }}</span>
              <svg
                style="display: flex; align-self: center"
                width="max(1.1vw, 16px)"
                height="max(1.1vw, 16px)"
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 0H2C1.175 0 0.5075 0.675 0.5075 1.5L0.5 10.5C0.5 11.325 1.175 12 2 12H14C14.825 12 15.5 11.325 15.5 10.5V1.5C15.5 0.675 14.825 0 14 0ZM14 3L8 6.75L2 3V1.5L8 5.25L14 1.5V3Z"
                  fill="#284767"
                />
              </svg>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorright" let-state>
        <div class="movanoPaginator">
          <svg (click)="previousPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.3333 5.33335L3.21996 5.33335L6.94663 1.60669L5.99996 0.666687L0.666626 6.00002L5.99996 11.3334L6.93996 10.3934L3.21996 6.66669L11.3333 6.66669V5.33335Z"
              [ngStyle]="{ fill: state.page > 0 ? '#0B84FF' : '#AABED3' }"
            />
          </svg>

          <button *ngIf="!isFirstPageInRange()" (click)="selectPage(1)" [ngClass]="{ 'active-page': actualPage === 1 }">
            1
          </button>

          <svg *ngIf="shouldShowLeftEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="8" rx="4" fill="#C4D9EE" />
            <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
          </svg>

          <button
            *ngFor="let page of getDisplayedPages()"
            [ngClass]="{ 'active-page': page === actualPage }"
            (click)="selectPage(page)"
          >
            {{ page }}
          </button>

          <svg *ngIf="shouldShowRightEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="8" rx="4" fill="#C4D9EE" />
            <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
          </svg>

          <button
            *ngIf="!isLastPageInRange()"
            (click)="selectPage(totalPages)"
            [ngClass]="{ 'active-page': actualPage === totalPages }"
          >
            {{ totalPages }}
          </button>

          <svg (click)="nextPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.666647 6.66665L8.77998 6.66665L5.05331 10.3933L5.99998 11.3333L11.3333 5.99998L5.99998 0.666646L5.05998 1.60665L8.77998 5.33331L0.666647 5.33331L0.666647 6.66665Z"
              [ngStyle]="{ fill: state.page < state.pageCount - 1 ? '#0B84FF' : '#AABED3' }"
            />
          </svg>
        </div>
      </ng-template>
    </p-table>
    <div id="mobileScroll" class="movanoTableBox_mobileShadow"></div>
    <div id="mobileScroll_Left" class="movanoTableBox_mobileShadow movanoTableBox_mobileShadow_Left"></div>
  </div>

  <div *ngIf="loadingUserList" style="position: absolute; top: 50%; left: 50%">
    <p-progressSpinner
      styleClass="{{ darkMode ? 'custom-spinner' : 'custom-spinner-blue' }}"
      strokeWidth="2"
      animationDuration="1.5s"
    >
    </p-progressSpinner>
  </div>
</div>
